import { combineReducers } from 'redux';

import { authReducer } from './auth/authReducer';
import { communitiesReducer } from './communities/communitiesReducer';
import { companiesReducer } from './companies/companiesReducer';
import { filesReducer } from './files/filesReducer';
import { inspectionsReducer } from './inspections/inspectionsReducer';
import { playerReducer } from './player/playerReducer';
import { propertiesReducer } from './properties/propertiesReducer';
import { tagsReducer } from './tags/tagsReducer';
import { threePointsReducer } from './threePoints/threePointsReducer';
import { timeCodesReducer } from './timeCodesReducer/timeCodesReducer';
import { userFileReducer } from './user-file/userFileReducer';
import { userInspectionReducer } from './user-inspection/userInspectionReducer';
import { usersReducer } from './users/usersReducer';

import { AuthActionType } from 'enums';
import { AppActionType } from 'state/types';

const appReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  properties: propertiesReducer,
  inspections: inspectionsReducer,
  communities: communitiesReducer,
  files: filesReducer,
  tags: tagsReducer,
  timeCodes: timeCodesReducer,
  player: playerReducer,
  threePoints: threePointsReducer,
  userFile: userFileReducer,
  companies: companiesReducer,
  userInspection: userInspectionReducer,
});

export const rootReducer = (state: AppRootStateType, action: AppActionType) => {
  return appReducer(action.type === AuthActionType.LOG_OUT ? undefined : state, action);
};

export type AppRootStateType = ReturnType<typeof appReducer>;
